import { upsertUseCase } from "./usecases/object";

export async function createNotification(message, notify, redirectTo) {
  await upsertUseCase().execute("notifications", {
    message,
    isRead: false,
    notify,
    redirectTo,
  });
}
